import { render, staticRenderFns } from "./ExternalSystemEdit.vue?vue&type=template&id=4561c6cc"
import script from "./ExternalSystemEdit.vue?vue&type=script&lang=js"
export * from "./ExternalSystemEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports